import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { CircularProgress, Box } from '@mui/material';

// Admin user IDs who can access admin features and reports
const ADMIN_USER_IDS = ['01Hy3G8tILYY3wJ4z2481xrGh493', 'DXXr7tC2Q7d8h3HFpRrwsOCEtKs2', 'bBetdjepqIenXUsp8tnPu1SeH7F3'];

interface AdminRouteProps {
  children: React.ReactNode;
}

export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login page with the current location as the return URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user is admin (using the same logic as in Header.tsx)
  const isAdmin = ADMIN_USER_IDS.includes(user?.uid || '');

  if (!isAdmin) {
    // Redirect to dashboard if not admin
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
